import { getAvatarData } from '../../utils/avatarUtils'
import { getFaceAvatar } from '../../utils/avatarFaces'

// Avatar de contacto con precedencia: cara elegida (Open Peeps) > iniciales + degradado.
// className define tamaño/forma (w-/h-/rounded-/text-). gradientOverride solo aplica al
// fallback de iniciales (p.ej. verde de is_manual). title/seed opcionales.
export default function ContactAvatar({ name, phone, seed, className = '', gradientOverride = null, title = '' }) {
  const face = seed ? getFaceAvatar(seed) : null
  if (face) {
    return (
      <img src={face} alt={name || phone || ''} title={title} draggable={false}
           className={`${className} object-cover bg-white select-none`} />
    )
  }
  const a = getAvatarData(name, phone)
  return (
    <div className={`${className} flex items-center justify-center text-white font-bold`}
         style={{ background: gradientOverride || a.gradient }} title={title}>
      {a.initials}
    </div>
  )
}
